import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useUrlSearchParams } from 'use-url-search-params';
import { Card, Button, OverlayTrigger, Form, Tooltip } from 'react-bootstrap';
import { Badge } from 'reactstrap';
import CsLineIcons from '../../../cs-line-icons/CsLineIcons';
import { Link } from 'react-router-dom';
import classnames from 'classnames';
import Pagination from '@vlsergey/react-bootstrap-pagination';
import { fetchAdvancePostingList, fetchAdvanceOrderDetails, addAdvancePosting, updateAdvancePostingStatus, notifyMaterialNaCancelledItems } from '../action/action';
import { SORTING_ORDER } from '../../../constants/index';
import moment from 'moment';
import AdvancePostingExport from './AdvancePostingExport';
import { DashBreadcrumb } from '../../../components/Common/Breadcrumb';
import FilterSearchQueue from '../../../components/FilterSearch/FilterSearchQueue';

import {
  Table,
  Row,
  Col,
  CardBody,
  CardTitle,
  CardSubtitle,
  CardHeader,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Spinner,
  NavLink,
  Nav,
  NavItem,
  FormGroup,
  Modal,
  Alert,
} from 'reactstrap';
import ReactDrawer from 'react-drawer';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import axios from 'axios';
import toast from 'react-hot-toast';
import { SuccessToast, ErrorToast } from '../../../utils/Toaster';

const ClickableBadge = ({ children, onClick, color = 'soft-warning', hoverColor = 'warning', ...props }) => {
  const [hover, setHover] = useState(false);
  
  let textColorClass = 'text-dark';
  if (color === 'soft-danger') {
    textColorClass = hover ? 'text-dark' : 'text-danger';
  }

  return (
    <Badge
      {...props}
      color={hover ? hoverColor : color}
      className={textColorClass}
      style={{ cursor: 'pointer', transition: '0.2s' }}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      onClick={onClick}
    >
      {children}
    </Badge>
  );
};
 
export const handleDrawerOpenRef = { current: null };
 
const AdvancePostingList = () => {
  const location = useLocation();

  const [btnprimary1, setBtnprimary1] = useState(false);

  const dispatch = useDispatch();

  const [sortingName, setSortingName] = useState({ id: 'sort.date_asc' });
  const [paginationValue, setPaginationValue] = useUrlSearchParams({ page: 0 });
  const [limitValue, setLimitValue] = useUrlSearchParams({ limit: 10 });
  const [sortingValue, setSortingValue] = useUrlSearchParams({
    sort: 'id',
    order: SORTING_ORDER.ASC,
  });
  const [searchValue, setSearchValue] = useUrlSearchParams({ search: '' });
  const [customActiveTab, setcustomActiveTab] = useState('');

  const [advancedFilter, setAdvancedFilter] = useState({});
  const [searchFilter, setSearchFilter] = useUrlSearchParams({ search: '' });
  const [statusFilter, setStatusFilter] = useUrlSearchParams({ status: 'All' });
  
  const { country = [] } = useSelector((state) => state.country);

  let currentCountry = localStorage.getItem('WEBSITE_COUNTRY');

  useEffect(() => {
    setDataLoading(true);
    fetchAdvancePostingList({
      params: {
        start: Number(paginationValue.page * limitValue.limit),
        limit: Number(limitValue.limit),
        sort: { value: sortingValue.sort, order: Number(sortingValue.order) },
        search_qry: searchFilter.search,
        status: statusFilter.status,
        orderBy: 'id',
        country: currentCountry || "",
        advancedFilter: advancedFilter,
      },
      dispatch,
    });
    setDataLoading(false);
  }, [
    paginationValue.page,
    limitValue,
    sortingValue.sort,
    searchFilter.search,
    statusFilter.status,
    advancedFilter,
    currentCountry
  ]);

  const limitByValues = [5, 10, 20, 50];
  const { advancePostingList = [], isLoading } = useSelector((state) => state.advancePosting);

  const [isDataLoading, setDataLoading] = useState(false);

  // Updated to match the provided API response structure
  // { data: [...], total: 5, start: 0, limit: 10 }
  const listOrders = advancePostingList?.advancePostingList; 
  const orderData = listOrders?.advancePosting || [];
  
  const handlePagination = (e) => {
    setPaginationValue({ page: e.target.value });
  };
  const handleLimit = (e) => {
    setLimitValue({ limit: Number(e) });
  };
  const handleSorting = (type, order = SORTING_ORDER.ASC, name) => {
    setSortingValue({ sort: type, order });
    setSortingName(name);
  };
  const handleSearch = (e) => {
    setSearchValue({ search: e.target.value });
  };

  let pageIndex = Number(listOrders?.start || 0);

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [drawerPosition] = useState('right');
  const [referenceNo, setReferenceNo] = useState('');
  const [advanceData, setAdvanceData] = useState();
  const [loadingAdvance, setLoadingAdvance] = useState(false);
  const [advanceError, setAdvanceError] = useState('');
  // Add Advance form state
  const [advancePostAmount, setAdvancePostAmount] = useState("");
  const [remark, setRemark] = useState("");
  const [amountError, setAmountError] = useState("");

  const [confirmModal, setConfirmModal] = useState(false);
  const [selectedOrderForApproval, setSelectedOrderForApproval] = useState(null);
  const [targetStatus, setTargetStatus] = useState(null); // 1 for Approve, 2 for Reject

  const [refundConfirmModal, setRefundConfirmModal] = useState(false);
  const [selectedOrderForRefund, setSelectedOrderForRefund] = useState(null);

  const [sendingEmailFor, setSendingEmailFor] = useState(null);

  const toggleConfirmModal = () => setConfirmModal(!confirmModal);
  const toggleRefundConfirmModal = () => setRefundConfirmModal(!refundConfirmModal);

  const handleStatusUpdateConfirm = async () => {
    if (!selectedOrderForApproval || !targetStatus) return;
    try {
      await updateAdvancePostingStatus({
        advance_reference_no: selectedOrderForApproval.advance_reference_no,
        status: targetStatus,
      });
      SuccessToast(`Status updated to ${targetStatus === 1 ? 'Approved' : 'Rejected'} successfully`);
      fetchAdvancePostingList({
        params: {
          start: Number(paginationValue.page * limitValue.limit),
          limit: Number(limitValue.limit),
          sort: { value: sortingValue.sort, order: Number(sortingValue.order) },
          search_qry: searchValue.search,
          status: customActiveTab,
          orderBy: 'id',
          country: "",
          advancedFilter: {},
        },
        dispatch,
      });
      setConfirmModal(false);
      setSelectedOrderForApproval(null);
      setTargetStatus(null);
    } catch (err) {
      ErrorToast('Failed to update status');
    }
  };

  const handleRefundStatusUpdateConfirm = async () => {
    if (!selectedOrderForRefund) return;
    try {
      await updateAdvancePostingStatus({
        advance_reference_no: selectedOrderForRefund.advance_reference_no,
        refund_status: 1, // Mark as Refunded
      });
      SuccessToast('Marked as Refunded successfully');
      fetchAdvancePostingList({
        params: {
          start: Number(paginationValue.page * limitValue.limit),
          limit: Number(limitValue.limit),
          sort: { value: sortingValue.sort, order: Number(sortingValue.order) },
          search_qry: searchValue.search,
          status: customActiveTab,
          orderBy: 'id',
          country: "",
          advancedFilter: {},
        },
        dispatch,
      });
      setRefundConfirmModal(false);
      setSelectedOrderForRefund(null);
    } catch (err) {
      ErrorToast('Failed to update refund status');
    }
  };

  // Handlers for Add Advance form
  const handleAdvancePostAmountChange = (e, balanceAmount) => {
    const val = e.target.value;
    setAdvancePostAmount(val);
    if (Number(val) > balanceAmount) {
      setAmountError("Advance amount cannot exceed Balance amount");
    } else {
      setAmountError("");
    }
  };
  const handleRemarkChange = (e) => setRemark(e.target.value);
  const handleAdvanceFormCancel = () => {
    setAdvancePostAmount("");
    setRemark("");
    setAmountError("");
    setDrawerOpen(false);
  };

  // Add Advance API submit
  const handleAddAdvanceSubmit = async (e) => {
    e.preventDefault();
    if (!advanceData?.OrderDetails?.[0]) return;
    
    let userName = '';
    let userID = '';
    if (localStorage.getItem('authUser')) {
      const userObj = JSON.parse(localStorage.getItem('authUser'));
      if (userObj?.role_id !== undefined) {
        userName = userObj?.user_name;
        userID = userObj?.user_id;
      }
    }

    const adv = advanceData.OrderDetails[0];
    const payload = {
      reference_no: adv.OrderNo,
      so_no: adv?.so_no || "",
      amount: Number(advancePostAmount),     
      created_at: adv?.CreatedDate || new Date().toISOString().slice(0, 19).replace('T', ' '),
      updated_at: new Date().toISOString().slice(0, 19).replace('T', ' '),
      remark: remark,     
      user_id: userID,
      created_by_username: userName,
    };
    try {
      await addAdvancePosting(payload);
      SuccessToast('Advance posted successfully!');
      fetchAdvancePostingList({
        params: {
          start: Number(paginationValue.page * limitValue.limit),
          limit: Number(limitValue.limit),
          sort: { value: sortingValue.sort, order: Number(sortingValue.order) },
          search_qry: searchValue.search,
          status: customActiveTab,
          orderBy: 'id',
          country: "",
          advancedFilter: {},
        },
        dispatch,
      });
      setAdvancePostAmount("");
      setRemark("");
      setAmountError("");
      setDrawerOpen(false);
    } catch (err) {
      ErrorToast(err?.response?.data?.message || 'Failed to post advance');
    }
  };

  const handleSendEmail = async (order) => {
    setSendingEmailFor(order.advance_reference_no || order.reference_no);
    try {
      await notifyMaterialNaCancelledItems({ ls_reference: order.so_no });
      SuccessToast('Email sent successfully');
      window.location.reload();
    } catch (err) {
      ErrorToast(err?.response?.data?.message || 'Failed to send email');
    }
    setSendingEmailFor(null);
  };

  const handleDrawerOpen = () => {
    setDrawerOpen(true);
    setReferenceNo('');
    setAdvanceData(undefined);
    setAdvanceError('');
  };
  const handleDrawerClose = () => setDrawerOpen(false);

  const handleAdvanceSubmit = async (e, values) => {
    setLoadingAdvance(true);
    setAdvanceError('');
    try {
      const res = await fetchAdvanceOrderDetails({ reference_no: values.reference_no, dispatch });
      if (res && res.OrderDetails && res.OrderDetails.length > 0) {
        setAdvanceData(res);
      } else {
        setAdvanceData(undefined);
        setAdvanceError(res?.message || 'Order Details Not Found');
      }
    } catch (err) {
      setAdvanceError(err?.response?.data?.message || 'Error fetching details');
      setAdvanceData(undefined);
    }
    setLoadingAdvance(false);
  };

  return (
    <>
      <Row className="mb-0">
        <Col>
          <DashBreadcrumb
            title="Orders"
            breadcrumbItem="Advance posting"
          />
        </Col>
        <Col xs="auto" className="d-flex justify-content-end align-items-start gap-2 pt-1">
          <button
            type="button"
            className="btn btn-dark"
            onClick={handleDrawerOpen}
            style={{ whiteSpace: 'nowrap' }}
          >
            Add Advance
          </button>
          <div style={{ minWidth: '550px' }}>
            <AdvancePostingExport />
          </div>
        </Col>
      </Row>

      <Row>
        <Col xl={12}>
          <FilterSearchQueue
            type="advanceposting"
            setAdvancedFilter={setAdvancedFilter}
            setSearchFilter={setSearchFilter}
            setStatusFilter={setStatusFilter}
          />
        </Col>
      </Row>

      <>
        {' '}
        <div className=" dt-table">
          {isLoading || isDataLoading ? (
            <Spinner className="ms-2 sploader" color="primary" />
          ) : null}
          {orderData?.length > 0 ? (
            <>
              <div className="table-responsive">
                <Table className="OrderListTable table mb-0">
                  <thead>
                    <tr>
                      <th>SI.No</th>
                      <th nowrap="nowrap">Reference No</th>
                      <th nowrap="nowrap">Advance Ref No</th>
                      <th nowrap="nowrap">SO No</th>
                      <th nowrap="nowrap">Amount</th>
                      <th nowrap="nowrap">Created At</th>
                      <th nowrap="nowrap">Remark</th>
                      <th nowrap="nowrap">Created By</th>
                      <th nowrap="nowrap">Ls Status</th>
                      <th nowrap="nowrap">Refund Status</th>
                      <th nowrap="nowrap">Status</th>
                      <th nowrap="nowrap">Action</th>
                    </tr>
                  </thead>
                  {(orderData || []).map((order, index) => {
                    pageIndex++;
                    return (
                      <tbody key={index}>
                        <tr>
                          <th scope="row">{pageIndex}</th>
                          <td>{order.reference_no}</td>
                          <td>{order.advance_reference_no || '-'}</td>
                          <td>{order.so_no || '-'}</td>
                          <td>{order.amount}</td>
                          <td>{moment(order.created_at).format('DD-MM-YYYY')}</td>
                          <td>
                            {order.remark ? (
                              <span title={order.remark} style={{ cursor: 'pointer' }}>
                                {order.remark.length > 30
                                  ? `${order.remark.substring(0, 30)}...`
                                  : order.remark}
                              </span>
                            ) : (
                              '-'
                            )}
                          </td>
                          <td>{order.created_by_username || '-'}</td>
                          <td>
                            {order.is_flow_ls === '1' || order.is_flow_ls === 1 ? (
                              <Badge
                                color="soft-info"
                                className="text-dark mt-1 me-1 "
                              >
                                Posted
                              </Badge>
                            ) : (
                              <Badge
                                color="soft-warning"
                                className="text-dark mt-1 me-1"
                              >
                                New
                              </Badge>
                            )}
                          </td>
                          <td>
                            {order.refund_status === '1' || order.refund_status === 1 ? (
                              <Badge color="soft-success" className="text-dark">
                                Refunded
                              </Badge>
                            ) : (
                              <ClickableBadge
                                color="soft-secondary"
                                hoverColor="secondary"
                                onClick={() => {
                                  setSelectedOrderForRefund(order);
                                  setRefundConfirmModal(true);
                                }}
                              >
                                Not Refunded
                              </ClickableBadge>
                            )}
                          </td>
                          <td>
                            {order.status === '1' ? (
                              <Badge color="soft-success" className=" text-dark">
                                Approved
                              </Badge>
                            ) : order.status === '2' ? (
                              <Badge color="soft-danger" className="text-dark">
                                Rejected
                              </Badge>
                            ) : (
                              <div className="d-flex gap-1">
                                <ClickableBadge
                                  onClick={() => {
                                    setSelectedOrderForApproval(order);
                                    setTargetStatus(1);
                                    setConfirmModal(true);
                                  }}
                                >
                                  Click to Approve
                                </ClickableBadge>
                                <ClickableBadge
                                  color="soft-danger" 
                                  hoverColor="danger"
                                  onClick={() => {
                                    setSelectedOrderForApproval(order);
                                    setTargetStatus(2);
                                    setConfirmModal(true);
                                  }}
                                >
                                  Reject
                                </ClickableBadge>
                              </div>
                            )}
                          </td>
                          <td>
                            {order.is_email_sent === '1' || order.is_email_sent === 1 ? (
                              <Badge color="soft-success" className="text-dark">
                                Email Sent
                              </Badge>
                            ) : (
                              <Button
                                type="button"
                                color="dark"
                                size="sm"
                                disabled={sendingEmailFor === (order.advance_reference_no || order.reference_no)}
                                onClick={() => handleSendEmail(order)}
                              >
                                {sendingEmailFor === (order.advance_reference_no || order.reference_no) ? (
                                  <Spinner size="sm" />
                                ) : (
                                  'Send Email'
                                )}
                              </Button>
                            )}
                          </td>
                        </tr>
                      </tbody>
                    );
                  })}
                </Table>
              </div>
              <div className="dataTblFooter">
                <div>
                  <Dropdown
                    isOpen={btnprimary1}
                    toggle={() => setBtnprimary1(!btnprimary1)}
                  >
                    <DropdownToggle tag="button" className="btn btn-dark">
                      {limitValue.limit} Items{' '}
                      <i className="mdi mdi-chevron-down" />
                    </DropdownToggle>
                    <DropdownMenu>
                      {limitByValues.map((limit, i) => {
                        return (
                          <DropdownItem
                            key={i}
                            href="#"
                            onClick={() => handleLimit(limit)}
                          >
                            {limit} Items
                          </DropdownItem>
                        );
                      })}
                    </DropdownMenu>
                  </Dropdown>
                </div>

                <div className="d-flex justify-content-center">
                  <Pagination
                    id="listPage"
                    value={paginationValue.page}
                    totalPages={listOrders?.recordsTotal || 0}
                    onChange={(e) => handlePagination(e)}
                  />
                </div>
              </div>
            </>
          ) : (
            <>
              <Table className="OrderListTable table mb-0">
                <thead>
                  <tr>
                    <th>SI.No</th>
                    <th>Reference No</th>
                    <th>Advance Ref No</th>
                    <th>SO No</th>
                    <th>Amount</th>
                    <th>Created At</th>
                    <th>Ls Status</th>
                    <th>Refund Status</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td colSpan={9}>No Records found</td>
                  </tr>
                </tbody>
              </Table>
            </>
          )}
        </div>
      </>
      <ReactDrawer
        open={drawerOpen}
        position={drawerPosition}
        onClose={handleDrawerClose}
        className="sideNavWidth"
      >
        <Card className="card-h-100 OrderDetailsBox" style={{ overflowY: 'scroll' }}>
          <CardHeader>
            <Row>
              <Col>
                <CardTitle>Add Advance Form</CardTitle>
              </Col>
              <Col className="textAlignRight">
                <button
                  type="button"
                  className="btn-close"
                  onClick={handleDrawerClose}
                  aria-label="Close"
                ></button>
              </Col>
            </Row>
          </CardHeader>
          <CardBody>
            {advanceError && (
              <Alert color="danger" className="mb-3">
                {advanceError}
              </Alert>
            )}
            <AvForm onValidSubmit={handleAdvanceSubmit}>
              <div className="search-input-container w-100 mb-3 position-relative">
                <AvField
                  name="reference_no"
                  label="Reference No"
                  value={referenceNo}
                  onChange={e => setReferenceNo(e.target.value)}
                  className="form-control"
                  placeholder=""
                  type="text"
                  required
                />
                <button
                  className="btn btn-dark "
                  type="submit"
                  style={{ position: 'absolute', top: 24, right: 0 }}
                  disabled={loadingAdvance}
                >
                  {loadingAdvance ? <Spinner size="sm" /> : <i className="bx bx-search-alt align-middle "></i>}
                </button>
              </div>
            </AvForm>

            {advanceData?.OrderDetails?.[0] && (() => {
              const adv = advanceData.OrderDetails[0];
              const paidAmount = Number(adv?.Amount) || 0;
              const advancePostedAmount = Number(adv?.AdvanceAmount) || 0;
              const balanceAmount = paidAmount - advancePostedAmount;
              return (
                <AvForm onValidSubmit={handleAddAdvanceSubmit}>
                  <Row>
                    <Col md="12">
                      <FormGroup className="mb-3">
                        <AvField
                          name="full_name"
                          label="Customer Name"
                          value={adv?.Fullname}
                          className="form-control"
                          type="text"
                          disabled
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="6">
                      <FormGroup className="mb-3">
                        <AvField
                          name="reference_no"
                          label="Reference No"
                          value={adv?.OrderNo}
                          className="form-control"
                          type="text"
                          disabled
                        />
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup className="mb-3">
                        <AvField
                          name="date"
                          label="Order Created date"
                          value={adv?.CreatedDate}
                          className="form-control"
                          type="text"
                          disabled
                        />
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup className="mb-3">
                        <AvField
                          name="amount"
                          label="Paid Amount"
                          value={paidAmount}
                          className="form-control"
                          type="text"
                          disabled
                        />
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup className="mb-3">
                        <AvField
                          name="advance_posted_amount"
                          label="Advance Posted Amount"
                          value={advancePostedAmount}
                          className="form-control"
                          type="text"
                          disabled
                        />
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup className="mb-3">
                        <AvField
                          name="balance_amount"
                          label="Balance Amount"
                          value={balanceAmount}
                          className="form-control"
                          type="text"
                          disabled
                        />
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup className="mb-3">
                        <AvField
                          name="payment_mode"
                          label="Payment Mode"
                          value={adv?.PaymentMode}
                          className="form-control"
                          type="text"
                          disabled
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="6">
                      <FormGroup className="mb-3">
                        <AvField
                          name="advance_post_amount"
                          label="Advance Post Amount"
                          value={advancePostAmount}
                          className="form-control"
                          type="number"
                          min={0}
                          max={balanceAmount}
                          onChange={e => handleAdvancePostAmountChange(e, balanceAmount)}
                          required
                        />
                        {amountError && (
                          <div style={{ color: 'red' }}>{amountError}</div>
                        )}
                      </FormGroup>
                    </Col>
                    <Col md="12">
                      <FormGroup className="mb-3">
                        <AvField
                          name="remark"
                          label="Remark"
                          value={remark}
                          className="form-control"
                          type="textarea"
                          onChange={handleRemarkChange}
                          rows={3}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <div className="d-flex justify-content-end gap-2">
                    <Button color="success" type="submit" disabled={!!amountError || !advancePostAmount}>
                      Submit
                    </Button>
                    <Button color="danger" type="button" onClick={handleAdvanceFormCancel}>
                      Cancel
                    </Button>
                  </div>
                </AvForm>
              );
            })()}
          </CardBody>
        </Card>
      </ReactDrawer>

      <Modal isOpen={confirmModal} toggle={toggleConfirmModal} centered>
        <div className="modal-header">
          <h5 className="modal-title mt-0">Confirm {targetStatus === 1 ? 'Approval' : 'Rejection'}</h5>
          <button
            type="button"
            onClick={toggleConfirmModal}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <p>Do you want to {targetStatus === 1 ? 'approve' : 'reject'} this advance posting?</p>
        </div>
        <div className="modal-footer">
          <Button
            type="button"
            color="light"
            outline
            onClick={toggleConfirmModal}
          >
            Cancel
          </Button>
          <Button
            type="button"
            color={targetStatus === 1 ? 'success' : 'danger'}
            onClick={handleStatusUpdateConfirm}
          >
            Yes
          </Button>
        </div>
      </Modal>

      <Modal isOpen={refundConfirmModal} toggle={toggleRefundConfirmModal} centered>
        <div className="modal-header">
          <h5 className="modal-title mt-0">Confirm Refund</h5>
          <button
            type="button"
            onClick={toggleRefundConfirmModal}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <p>Are you sure you want to mark this advance posting as Refunded?</p>
        </div>
        <div className="modal-footer">
          <Button
            type="button"
            color="light"
            outline
            onClick={toggleRefundConfirmModal}
          >
            Cancel
          </Button>
          <Button
            type="button"
            color="success"
            onClick={handleRefundStatusUpdateConfirm}
          >
            Yes, Refunded
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default AdvancePostingList;
